import Axios from 'axios'

import {
  XsrfResilient,
  areAllShipmentsAssigned,
} from '@/services/Helpers'

import {
  standardizeOrder,
  MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'

import { log } from '@/services/Log'

import { finalizePendingOrder } from './finalizePendingOrder'

const ORDER_STATUS_INCOMPLETE = 'INCOMPLETE'

export const getOrder = XsrfResilient(async ({ cart, cart: { id: checkoutID } }) => {
  log('getOrder START', { cart, checkoutID })
  if (!checkoutID) {
    return false
  }

  // Returns a Checkout. - https://developer.bigcommerce.com/api-reference/storefront/checkouts/checkout/checkoutsbycheckoutidget
  const { data: order } = await Axios.get(`/api/storefront/checkouts/${checkoutID}?include=consignments.availableShippingOptions`)

  let status = ORDER_STATUS_INCOMPLETE // default status, can be overridden by real status

  // Checking if the order has been finalized
  if (order?.orderId) {
    // Returns Order data. - https://developer.bigcommerce.com/api-reference/storefront/orders/order/ordersbyorderidget
    // This will return order data immediately after an order is placed on the storefront.
    const fullOrder = (await Axios.get(`/api/storefront/orders/${order?.orderId}`)).data
    status = fullOrder?.status
    await finalizePendingOrder({ orderId: order?.orderId })
  }
  const newOrder = standardizeOrder({ ...order, status }, cart)
  await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
  log('getOrder END', { newOrder, areAllShipmentsAssigned: areAllShipmentsAssigned(newOrder) })
  return newOrder
})
